import React from "react";
// import Wave from "react-wavify";

import { MainWrapper } from "./components";
import PageOutline from "../../components/page-outline/PageOutline";

const Music = () => {
  return (
    <PageOutline header={{ title: "Dance with me!" }}>
      <MainWrapper>
        {/* <img style={{width: 160, height: 160}} source={require('../../assets/Background.png')}/> */}
        {/* <Wave
          options={{
            height: 40,
            amplitude: 20,
            speed: 1,
            points: 7,
          }}
          mask="url(#mask)"
          fill="#1277b0"
        >
          <defs>
            <linearGradient id="gradient" gradientTransform="rotate(90)">
              <stop offset="0" stopColor="white" />
              <stop offset="0.5" stopColor="black" />
            </linearGradient>
            <mask id="mask">
              <rect x="0" y="0" width="2000" height="200" fill="url(#gradient)" />
            </mask>
          </defs>
        </Wave> */}
      </MainWrapper>
    </PageOutline>
  );
};

export default Music;
